import { useState } from 'react';
import axios from 'axios';

import { useCms } from '~/components/hooks/useCms';
import type { CreateSignatureRequestResponse } from '~/server_shared/openapi/data-contracts';
import { reportAxiosError } from '~/Utils';

interface UseSigningUrlReturn {
  fetchSigningUrl: (requestId: number) => Promise<string | null>;
  isLoading: boolean;
}

export const useSigningUrl = (): UseSigningUrlReturn => {
  const { userOrganization } = useCms();
  const [isLoading, setIsLoading] = useState(false);

  const fetchSigningUrl = async (requestId: number): Promise<string | null> => {
    setIsLoading(true);

    try {
      const response = await axios.get<CreateSignatureRequestResponse>(
        `/api/v1/organizations/${userOrganization.id}/e_sign/signature_requests/${requestId}/signing_url`
      );

      setIsLoading(false);
      return response.data.sign_url;
    } catch (err) {
      setIsLoading(false);
      reportAxiosError(err);
      return null;
    }
  };

  return {
    fetchSigningUrl,
    isLoading,
  };
};
